

import React, { useEffect } from 'react';
import '../Assets/Css/about.css'
import { Container, Row, Col, Card } from 'react-bootstrap';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import { FaTools, FaIndustry, } from 'react-icons/fa';
import { FaBuilding, FaHardHat, FaShieldAlt } from "react-icons/fa";
import { FaHandsHelping, FaAward, FaChartLine, FaClock } from 'react-icons/fa';

import ctaimgabout from '../Assets/Image/aboutcts.avif'
import { FaBullseye, FaEye } from 'react-icons/fa';
import aboutimg from '../Assets/Image/pradhservices.png'
import {

  FaUsersCog
} from "react-icons/fa";
import { FaBroom, FaPeopleCarry } from 'react-icons/fa';


import AOS from 'aos';
import 'aos/dist/aos.css';
import { Helmet } from 'react-helmet';

export default function About() {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);




  const testimonials = [
    {
      message: "Pradh Management Solutions transformed our facility operations with their exceptional cleaning and MEP services. Highly professional and reliable.",
      author: "Facility Manager",
    },
    {
      message: "Their integrated services — from manpower supply to civil maintenance — have brought great efficiency and peace of mind to our organization.",
      author: "Admin Head",
    },
    {
      message: "We've been working with Pradh for over  years, and their commitment to safety, quality, and timely execution has consistently exceeded expectations.",
      author: "Operations Director",
    },
  ];

  const features = [
    {
      icon: <FaHandsHelping size={28} />,
      title: 'Trusted Partnership',
      description: 'Building long-term relationships with a focus on mutual growth and operational success.',
    },
    {
      icon: <FaAward size={28} />,
      title: 'Unmatched Quality',
      description: 'Rigorous service standards and quality checks ensure consistent, superior performance.',
    },
    {
      icon: <FaChartLine size={28} />,
      title: 'Proven Track Record',
      description: 'Successfully executed diverse projects across industries with a commitment to excellence.',
    },
    {
      icon: <FaClock size={28} />,
      title: 'Timely Execution',
      description: 'We prioritize punctual delivery without compromising on safety or excellence.',
    },
  ];


  return (
    <>
      <div className="mainnav min-vh-100">
        <Helmet>
          {/* Basic SEO */}
          <title>About Us | Pradh Management Solutions – Industrial & Facility Services</title>
          <meta
            name="description"
            content="Learn about Pradh Management Solutions – India's trusted provider of integrated industrial, commercial, and facility services. Discover our mission, vision, expertise, and sector-wide solutions."
          />
          <meta
            name="keywords"
            content="About Pradh, Industrial Facility Management, Commercial Cleaning India, Facility Services Provider, MEP, Civil, Manpower, Pest Control, Fabrication, Housekeeping"
          />
          <meta name="author" content="Pradh Management Solutions" />
          <meta name="robots" content="index, follow" />

          {/* Open Graph / Facebook */}
          <meta property="og:title" content="About Us | Pradh Management Solutions" />
          <meta
            property="og:description"
            content="Pradh Management Solutions empowers industries across India with expert facility services—from cleaning and MEP to construction and manpower."
          />
          <meta property="og:url" content="https://pradh.com/about" />
          <meta property="og:type" content="website" />
          <meta property="og:image" content="https://pradh.com/images/about-banner.jpg" />

          {/* Twitter */}
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content="About Us | Pradh Management Solutions" />
          <meta
            name="twitter:description"
            content="Leading provider of industrial and commercial facility services in India. Discover our mission, expertise, and operational excellence."
          />
          <meta name="twitter:image" content="https://pradh.com/images/about-banner.jpg" />

          {/* Canonical */}
          <link rel="canonical" href="https://pradh.com/about" />
        </Helmet>
        {/* Hero Section */}
        <section className="hero-section1">
          <div className="overlay">
            <h1 data-aos="zoom-in">ABOUT US

            </h1>
            <p data-aos="zoom-in">Empowering industries through reliable facility and <br /> operational support services</p>
            <a href="/contact" className="btn-get" data-aos="fade-up">Get in Touch</a>
          </div>
        </section>

        {/* About Section */}
        <section className="about-preview py-5">
          <Container>
            <Row className="align-items-center">
              {/* Text Section */}
              <Col md={7}>
                <h2 className='page-title' data-aos="fade-up">About Us</h2>
                <div style={{ textAlign: 'justify' }} data-aos="zoom-in" data-aos-delay="100">
                  <p >
                    <strong style={{ color: '#04A1D3' }}> Pradh Management Solutions</strong>  is a leading provider of integrated industrial and commercial services across India. With a strong focus on quality, safety, and reliability, we deliver specialized solutions tailored to meet the operational needs of businesses, institutions, and infrastructure facilities.
                  </p>
                  <p>
                    With years of hands-on experience and a team of trained professionals, Pradh offers a comprehensive range of <b>Services - </b>
                    High-rise and industrial cleaning,

                    MEP (Mechanical, Electrical & Plumbing) solutions,

                    Civil and construction works,

                    Industrial painting and waterproofing,

                    Pest and bird control services,

                    Industrial manpower and mechanized housekeeping,

                    Custom fabrication and on-site maintenance.
                  </p>
                  <p>
                    We serve a diverse clientele across sectors such as manufacturing, real estate, healthcare, education, logistics, and hospitality. Whether it’s a factory floor, a commercial tower, or a residential complex, Pradh ensures every project is executed with precision, professionalism, and care.
                  </p>
                  <p>
                    Our commitment is to optimize facilities, improve safety, and enhance operational efficiency—delivering value beyond just services.
                  </p>
                </div>
              </Col>
              {/* Image Section */}
              <Col md={5}>
                <img
                  src={aboutimg}
                  alt="Teamwork and Services"
                  className="img-fluid aboutimg rounded shadow"
                  data-aos="zoom-in" data-aos-delay="200"
                />
              </Col>
            </Row>
          </Container>
        </section>

        <div className="mv-hex-section py-5">
          <Container>
            <h2 className="page-title" data-aos="fade-up">
              Our Mission & Vision
            </h2>
            <Row className="justify-content-center">
              <Col md={10} >
                <div className="hex-container" >
                  <div className="hex-wrapper" data-aos="zoom-in" data-aos-delay="300">
                    <div className="hex-part top-left"></div>
                    <div className="hex-part top-right"></div>
                    <div className="hex-part bottom-left"></div>
                    <div className="hex-part bottom-right"></div>
                    <div className="hex-content">
                      <FaBullseye size={20} />
                      <h4>Mission</h4>
                      <p>
                        Empowering businesses with reliable, safe, and customized
                        solutions by continuously enhancing our technology,  and
                        processes to deliver consistent, high-quality services.
                      </p>
                      <p>
                      </p>
                    </div>
                  </div>

                  <div className="hex-wrapper" data-aos="zoom-in" data-aos-delay="400">
                    <div className="hex-part top-left"></div>
                    <div className="hex-part top-right"></div>
                    <div className="hex-part bottom-left"></div>
                    <div className="hex-part bottom-right"></div>
                    <div className="hex-content">
                      <FaEye size={20} />
                      <h4>Vision</h4>
                      <p>
                        To become India’s most trusted partner in industrial and
                        commercial services by delivering innovative, high-quality
                        solutions driven by safety, excellence, and integrity.
                      </p>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>

        <section className="motto-section">
          <div className="overlaymotto">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-md-8 p-4 motto-content text-center">
                  <h2 className="page-title" data-aos="fade-up">
                    Our Motto
                  </h2>
                  <p>
                    Creating a secure and uplifting work environment like <strong>Pradh Management Solutions</strong> through our exceptional services.
                    Our offerings are carried out by skilled professionals committed to delivering high-quality outcomes with precision.
                    Clients value our services for their adaptability, trustworthiness, customized solutions, and prompt execution.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>


        <section className="industries-we-serve py-5  bg-light">
          <Container>
            <h2 className="page-title" data-aos="fade-up">
              Solutions Crafted for Every Sector
            </h2>
            <Row className="g-4 mt-3">
              {[
                {
                  title: 'Integrated Cleaning Solutions',
                  icon: <FaBroom size={40} color="#EE6602" />,
                  description: 'Comprehensive high-rise, industrial, and deep-cleaning services designed for efficiency and hygiene.',
                },
                {
                  title: 'Facility & Maintenance Services',
                  icon: <FaTools size={40} color="#04A1D3" />,
                  description: 'Reliable MEP, general maintenance, and IFM services that keep your operations running smoothly.',
                },
                {
                  title: 'Civil, Painting & Construction',
                  icon: <FaHardHat size={40} color="#C52316" />,
                  description: 'Robust solutions for industrial construction, coatings, and infrastructure enhancement.',
                },
                {
                  title: 'Workforce & Environmental Support',
                  icon: <FaPeopleCarry size={40} color="#C7DE2C" />,
                  description: 'Skilled manpower, mechanized housekeeping, pest, and bird control solutions tailored to your space.',
                },
              ].map((service, index) => (
                <Col key={index} md={3} sm={6} xs={12}>
                  <div className="industry-card text-center p-4 h-100" data-aos="flip-up">
                    <div className="industry-icon mb-3">{service.icon}</div>
                    <h5 className="industry-title mb-2">{service.title}</h5>
                    <p className="industry-description">{service.description}</p>
                  </div>
                </Col>
              ))}
            </Row>
          </Container>
        </section>


        <section className="expertise-section py-5 ">
          <Container>
            <h2 className="page-title" data-aos="fade-up">
              Our Areas of Expertise
            </h2>
            <Row className="g-4">
              {[
                {
                  title: 'Industrial Solutions',
                  icon: <FaIndustry size={40} />,
                  description: 'Efficient cleaning, fabrication, and tank maintenance tailored for heavy industries.',
                },
                {
                  title: 'Commercial Infrastructure',
                  icon: <FaBuilding size={40} />,
                  description: 'End-to-end commercial services including HVAC, civil construction, and IFM.',
                },
                {
                  title: 'Safety & Compliance',
                  icon: <FaShieldAlt size={40} />,
                  description: 'Services focused on safety, fire systems, pest control, and waterproofing.',
                },
                {
                  title: 'Manpower & Facility Support',
                  icon: <FaUsersCog size={40} />,
                  description: 'Smart workforce and housekeeping services to support efficient facility management.',
                },
              ].map((item, index) => (
                <Col key={index} md={3} sm={6} xs={12}>
                  <div className="expertise-card text-center p-4 h-100" data-aos="fade-up">
                    <div className="expertise-icon mb-3">{item.icon}</div>
                    <h5 className="expertise-heading mb-2">{item.title}</h5>
                    <p className="expertise-desc">{item.description}</p>
                  </div>
                </Col>
              ))}
            </Row>
          </Container>
        </section>


        <section className="whychooseus-section py-5">
          <Container>
            <h2 className="page-title" data-aos="fade-up">Why Choose Pradh?</h2>
            <Row className="gx-4 gy-3">
              {features.map((item, index) => (
                <Col key={index} md={6}>
                  <div className={`chooseus-block ${index % 2 === 0 ? 'left' : 'right'}`} data-aos="fade-up" data-aos-delay={index * 100}>
                    <div className="chooseus-icon">{item.icon}</div>
                    <div className="chooseus-content">
                      <h5>{item.title}</h5>
                      <p>{item.description}</p>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </Container>
        </section>

        <section className="cta-section text-white py-4">
          <Container>
            <Row className="align-items-center">
              <Col md={6}>
                <div className="d-flex justify-content-center">
                  <img
                    src={ctaimgabout}
                    alt="Pradh team delivering professional facility solutions"
                    className="img-fluid ctaimg rounded shadow mb-2"
                    data-aos="zoom-in"
                    data-aos-delay="100"
                  />
                </div>
              </Col>

              <Col md={6} className="text-center text-md-start mb-3" data-aos="zoom-in" data-aos-delay="200">
                <h2 className="fw-bold">End-to-End Facility & Manpower Solutions</h2>
                <p className="lead">
                  From industrial cleaning and maintenance to expert manpower deployment — Pradh delivers integrated services tailored to your operational needs.
                </p>
                <a href="/services" className="btn-learn mt-3">Explore Our Services</a>
              </Col>
            </Row>
          </Container>
        </section>


        <section className="testimonials py-5 bg-light">
          <Container>
            <h2 className="page-title text-center" data-aos="fade-up"> What Our Clients Say </h2>
            <Row>
              <Col md={{ span: 8, offset: 2 }}>
                <Swiper
                  modules={[Autoplay, Pagination]}
                  spaceBetween={30}
                  slidesPerView={1}
                  autoplay={{ delay: 5000 }}
                  loop={true}
                  pagination={{ clickable: true }}
                >
                  {testimonials.map((testimonial, index) => (
                    <SwiperSlide key={index}>
                      <Card className="p-4 mb-4  border-0" data-aos="zoom-in" data-aos-delay="100">

                        <p>⭐️⭐️⭐️⭐️⭐️</p>

                        <p className="mb-3 " style={{ fontStyle: 'italic' }}>“{testimonial.message}”</p>

                        <small className="text-muted">— {testimonial.author}</small>
                      </Card>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </Col>
            </Row>
          </Container>
        </section>
      </div>
    </>
  );
}
